// extracted by mini-css-extract-plugin
export default {"root":"Pic__root--3NeL6","container":"Pic__container--2wB9j","icon":"Pic__icon--vp7zm","thumb":"Pic__thumb--2y8nW","thumb_loaded":"Pic__thumb_loaded--2wzK7"};